import { firestore } from "../../config/firebase";
import { doc, updateDoc } from "firebase/firestore";

const updateInvestmentPromo = async (id, obj) => {
  const investmentPromoRef = doc(firestore, "investmentPromos", id);
  await updateDoc(investmentPromoRef, obj);
};

export default updateInvestmentPromo;